import { connect } from 'react-redux';
import { setMessage } from '../actions/signIn';
import CreatePassword from './CreatePassword';

const mapDispatchToProps = (dispatch: any) => ({
  setMessage: (message: string) => dispatch(setMessage(message))
});

export default connect(() => ({}), mapDispatchToProps)(CreatePassword);
